/**
 * 正则验证
 */
export const PATTERN_MOBILE = /[1][3-9][0-9]{9}$/;
export const PATTERN_AUTHCODE = /[0-9]{6}$/;

/**
 * 判断是否为iPhone
 */
export const isIPhone = new RegExp('\\biPhone\\b|\\biPod\\b', 'i').test(window.navigator.userAgent);
